module.exports = __webpack_public_path__ + "img/Add ons.dfdd83fc.svg";